import React, { useRef, useImperativeHandle } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMoreModule from 'highcharts/highcharts-more'; // For arearange support
import ExportingModule from 'highcharts/modules/exporting'; // For exporting (optional)

// Initialize Highcharts modules
const HighchartsMore = HighchartsMoreModule.default || HighchartsMoreModule; // Handle ES module default export
const Exporting = ExportingModule.default || ExportingModule; // Handle ES module default export

if (typeof Highcharts === 'object') {
    try {
        HighchartsMore(Highcharts); // Initialize arearange support
        Exporting(Highcharts); // Initialize exporting module
    } catch (error) {
        console.error('Error initializing Highcharts modules:', error);
    }
} else {
    console.error('Highcharts core library not loaded');
}

function HazardOccurencesChart({ chartData, headingText, ref }) {

    const chartRef = useRef(null);

    // Expose a function to download the chart
    useImperativeHandle(ref, () => ({
        downloadPNG,
    }));

    const downloadPNG = () => {
        if (chartRef.current) {
            const chart = chartRef.current.chart;
            const svg = chart.getSVG(); // Get SVG string
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            const svgBlob = new Blob([svg], { type: "image/svg+xml;charset=utf-8" });
            const url = URL.createObjectURL(svgBlob);

            img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                URL.revokeObjectURL(url);

                // Convert canvas to PNG and trigger download
                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                link.download = "chart.png";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            };

            img.src = url;
        }
    };
    if (typeof Highcharts === 'object') {
        //HighchartsExporting(Highcharts)
        //exporting(Highcharts);
    }

    const options = {
        chart: {
            type: 'column',
            height: 450,
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            type: 'category',
            title: {
                text: `${headingText}`
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: 'No of Occurrences'
            }
        },

        exporting: {
            enabled: true
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        series: [{
            name: 'Occurrences',
            data: chartData
        }],
        exporting: {
            enabled: false,
        },
    };

    return (
        <>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
                ref={chartRef}
            />
        </>
    )
}

export default HazardOccurencesChart